// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"4359":"catalogo-ui-americanas-mobile-product-gallery","5458":"catalogo-template-americanas-mobile-product","9200":"catalogo-modal-americanas-mobile-o2o-product"}[chunkId] + "." + {"4359":"7d4a9b17","5458":"7d4a9b17","9200":"e3ce828c"}[chunkId] + ".chunk.css";
};